import {UUID_NULL} from '../constants/defaultValues'
import {SET_USER, SENDING_USER_CHANGE_PASSWORD, USER_CHANGE_PASSWORD_FAILURE, USER_CLEAR_ERROR} from '../actions/constants'

const initialState = {
  currentUser: {
    ID: UUID_NULL,
    Name: 'default'
  },
  error: '',
  fetching: false
}

const user = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER:
      return {
        ...state,
        currentUser: action.newUserState
      }
    case SENDING_USER_CHANGE_PASSWORD:
      return {
        ...state,
        fetching: action.sending
      }
    case USER_CHANGE_PASSWORD_FAILURE:
      return {
        ...state,
        error: action.error
      }
    case USER_CLEAR_ERROR:
      return {
        ...state,
        error: ""
      }
    default:
      return state
  }
}

export default user



// WEBPACK FOOTER //
// ./src/reducers/user.js